import { motion, useReducedMotion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: EASE }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const Contours = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 800 600"
    fill="none"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
  >
    {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
      <path
        key={i}
        d={`M -60 ${90 + i * 68} C 180 ${20 + i * 68}, 430 ${170 + i * 68}, 860 ${70 + i * 68}`}
        stroke="currentColor"
        strokeWidth="1"
      />
    ))}
  </svg>
);
